import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import { GetCustomersResponse } from '@/api/agency/customers/get-customers'

export const mockGetCustomers = http.get(
  '/my-business/api/agency/v1/customers/list',
  (req) => {
    const searchParams = new URL(req.request.url).searchParams

    const data: GetCustomersResponse = {
      page: Number(searchParams.get('page') ?? 1),
      perPage: Number(searchParams.get('perPage') ?? 10),
      total: 100,
      totalPages: 10,
      data: Array.from({
        length: Number(searchParams.get('perPage') ?? 10),
      }).map(() => ({
        alphaId: faker.string.uuid(),
        id: faker.string.numeric(6),
        code: faker.string.alphanumeric(6).toUpperCase(),
        name: faker.company.name(),
        taxPayerId: faker.string.numeric(14),
        cityName: faker.location.city(),
        stateCode: faker.helpers.arrayElement(['SP', 'RJ', 'MG', 'ES', 'RS']),
        active: true,
      })),
    }

    return HttpResponse.json(data, { status: 200 })
  },
)
